import {
    IEditStatePointResult, renderCompleteInfo, IStatePointResult,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

export default class EditSlideRenderStatePoint {
    // 编辑区渲染完成信息map
    private editSlideRenderCompleteMap: Map<string, renderCompleteInfo> = new Map();

    /**
     * 获取指定slide渲染完成时间的promise（不仅仅是首次）
     * 当slideComponent被销毁时会重置此promise
     * @param slide
     */
    public getEditSlideRenderCompletePromiseByModel(slide: ISlideModel): Promise<IStatePointResult> {
        let slideRenderComplete = this.editSlideRenderCompleteMap.get(slide.key);
        if (!slideRenderComplete) {
            slideRenderComplete = {};
            slideRenderComplete.promise = new Promise((resolve) => {
                if (slideRenderComplete) {
                    slideRenderComplete.resolve = resolve;
                }
            });
            this.editSlideRenderCompleteMap.set(slide.key, slideRenderComplete);
        }
        return slideRenderComplete.promise!;
    }

    /**
     * 重置编辑区slide渲染完成promise
     * 因为编辑区的slide有着基于性能考虑的不可见即销毁的策略
     * 所以不重置而只使用首次渲染的promise，那是不准确的
     * @param slide
     */
    public async resetEditSlideRenderCompletePromise(slide: ISlideModel): Promise<void> {
        const editSlideRenderComplete = this.editSlideRenderCompleteMap.get(slide.key);
        if (editSlideRenderComplete?.latestTime) {
            editSlideRenderComplete.latestTime = undefined;
            editSlideRenderComplete.promise = new Promise((resolve) => {
                if (editSlideRenderComplete) {
                    editSlideRenderComplete.resolve = resolve;
                }
            });
        }
    }

    public emitPointComplete(params: IEditStatePointResult): void {
        const { time, entry, slide } = params;
        const editSlideRenderComplete = this.editSlideRenderCompleteMap.get(slide.key);

        // 任意一次切页（非首次 or 首次）
        eventBus.emit(
            EventKeys.SLIDE_CHANGE_INDEX_AFTER,
            slide.parent?.children.findIndex(e => e === slide) ?? -1,
        );

        if (editSlideRenderComplete?.latestTime) {
            // 只有首次渲染或者不可见后slideComponent被销毁从而被重置才会记录往下走，重复render不被记录
            return;
        }

        if (editSlideRenderComplete) {
            editSlideRenderComplete.latestTime = time;
            editSlideRenderComplete.firstTime = editSlideRenderComplete.firstTime ?? time;
            editSlideRenderComplete.resolve?.({ time, entry });
        } else {
            this.editSlideRenderCompleteMap.set(slide.key, {
                firstTime: time,
                latestTime: time,
                promise: Promise.resolve({ time, entry }),
            });
        }
    }
}
